<template>
  <div id="main-wrap">
    <div id="main">
      <div
        :class="{iscustomRouter: customRouters.includes($route.name)}"
        :style="{
          minHeight: `${pagesHeight}px`,
          overflow: 'hidden'
        }"
      >
        <div
          :class="{iscustomRouter: customRouters.includes($route.name)}"
          :style="{
            width: '1920px',
            minHeight: bodyHeight || '1080px',
            transformOrigin: 'left top',
            transform: customRouters.includes($route.name) ? `scale(${scalseNum}, 1)` : `scale(${scalseNum})`,
            '-webkit-transform': customRouters.includes($route.name) ? `scale(${scalseNum}, 1)` : `scale(${scalseNum})`,
            '-moz-transform': customRouters.includes($route.name) ? `scale(${scalseNum}, 1)` : `scale(${scalseNum})`,
            '-o-transform': customRouters.includes($route.name) ? `scale(${scalseNum}, 1)` : `scale(${scalseNum})`,
            '-ms-transform': customRouters.includes($route.name) ? `scale(${scalseNum}, 1)` : `scale(${scalseNum})`,
            display: 'flex',
            'flex-direction': 'column',
            overflow: 'hidden'
          }"
        >
          <div class="main-header">
            <div class="header-left">
              <!-- <div class="logo xx" :style="{backgroundImage:'url('+require('@/assets/images/logo.png')+')'}"></div> -->
              <div class="site-name xx">
                {{
                  $route.meta.title === 'dynamic'
                    ? dynamicTitle[$route.query.type]
                    : $route.meta.title
                }}
              </div>
              <span
                v-if="showSelectDate"
                class="coocaa_btn xx"
                id="select-mounth"
                rightTarget="#index"
                rel="selectMonth"
                @click="selectMonth"
              >
                选择月份：{{ yearMonth }} <i class="el-icon-d-caret"></i>
              </span>
              <span class="xx">数据统计时间至：{{ cutOffDate }}</span>
              <span class="marquee-button" @click="jumpPage" v-if="isAbnormal">
                <span class="marquee-button-text">异常分析查看</span>
              </span>
            </div>
            <div class="header-right" v-if="!isHideInMenu">
              <div class="nav">
                <ul>
                  <!-- v-show="(isQuality && item.name === 'Quality') || item.name !== 'Quality'" -->
                  <li
                    v-show="(isQuality && item.name === 'Quality') || item.name !== 'Quality'"
                    v-for="(item, key) in menu"
                    :key="key"
                    class="coocaa_btn"
                    :leftTarget="getNavLeftTarget(item.name)"
                    downTarget="#project_0"
                    :id="item.name"
                    rel="toNav"
                  >
                    <span
                      :src="`${item.path}`"
                      :routeName="item.path"
                      :class="{
                        curTab: $route.name === item.name
                      }"
                      @click="handleClickLink(item.path)"
                    >{{ item.meta.tab }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="header-right" v-else>
              <!-- <div class="return-page coocaa_btn" rel="back">返回 <span class="el-icon-arrow-right"></span></div> -->
              <div
                class="return-page coocaa_btn"
                rel="back"
                id="back"
                @click="handleBack"
              >
                返回 <span class="el-icon-arrow-right"></span>
              </div>
              <!-- <div
            class="return-page"
            v-else
            rel="back"

          >
            返回 <span class="el-icon-arrow-right"></span>
          </div> -->
            </div>
          </div>
          <div class="main-body" v-if="menu.length" style="max-width: 96rem">
            <keep-alive>
              <router-view v-if="isKeepAlive" :name="routerName"></router-view>
            </keep-alive>
            <router-view v-if="!isKeepAlive" :name="routerName"></router-view>
          </div>
          <div class="no-data" v-if="!menu.length && !loading">
            暂无任何权限
          </div>
        </div>
      </div>
      <!-- v-if="IsAndroid" -->
      <!-- <FullScreenCompont
        v-if="IsAndroid"
        :is-full="IsFull"
        @setFull="setFull"
        @cancelFull="cancelFull"
      ></FullScreenCompont> -->
    </div>
  </div>
</template>

<script>
import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
// import FullScreenCompont from '@/components/FullScreenCompont.vue'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  mixins: [ccMapMixin, common, scalseNum],
  components: {},
  props: {},
  data () {
    return {
      dynamicTitle: {
        closePic: '闭环率详情',
        directPic: '直客销售详情',
        recordPic: '销售效能详情'
      },
      prevId: '',
      keyCode: '',
      cutOffDate: '',
      loading: false,
      showSelectDate: false, // 测试
      isQuality: true, // 是否展示香港菜单
      customRouters: ['Finance', 'Quality'], // 自定义页面
      menuList: []
    }
  },
  watch: {
    '$route.name': 'setShowSelectDate'
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    },
    isKeepAlive () {
      const meta = this.$route.meta
      return meta && meta.isCache !== false
    },
    isHideInMenu () {
      return this.$route.meta.hideInMenu
    },
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    },
    menu () {
      const menuList = this.$router.options.routes[0].children.filter((v) => this.menuList.includes(v.meta.tab))
      return menuList || []
    },
    yearMonth () {
      return JSON.parse(sessionStorage.getItem('toggleDate')).time
    },
    month () {
      const date = new Date()
      return date.getMonth() + 1
    },
    ...mapGetters('router', {
      routerName: 'GetName'
    }),
    isAbnormal () {
      return this.$store.state.app.abnormal
    }
  },
  methods: {
    getMenuAuth () {
      this.$service
        .fetch({
          url: '/api/finance-api/operation/permission'
        })
        .then((res) => {
          this.isQuality = res
          console.log('res-getMenuAuth: ', res)
        })
    },
    getAllMenuList () {
      this.loading = true
      this.$service
        .fetch({
          url: '/api/finance-api/operation/menu'
        })
        .then((res) => {
          this.menuList = res || []
          this.loading = false
          if (this.menuList.length && !this.menuList.includes(this.$route.meta.tab)) {
            this.$router.replace(this.menu[0].path)
          }
        }).catch(res => {
          this.loading = false
        })
    },
    // handleTabShakeAnim (projectID, curIndex) {
    //   if (prevPanelId == 0 && (curIndex == 0 || curIndex == this.tabList.length - 1)) {
    //     console.log('Hi Guys, 准备抖动吧...', curIndex)
    //     $(`#tabIndex${curIndex}`).addClass('shakeAnim').one('animationend', function () {
    //       console.log('抖动完毕')
    //       $(`#tabIndex${curIndex}`).removeClass('shakeAnim')
    //     })
    //   }
    // },
    selectMonth () {
      localStorage.setItem('returnPage', location.pathname + location.search)
      location.href = '/select-month'
      // if (this.keyCode) {
      //   this.keyCode = 0
      // } else {
      //   // this.setRoute()
      //   this.$router.push({ name: 'select-month' })
      // }
    },
    setRoute () {
      const route = JSON.parse(this.$routeInfo('get'))
      this.$router.push({
        name: this.$route.name,
        query: this.$route.query
      })
      this.$routeInfo('set', JSON.stringify(route))
    },
    setCutOffDate () {
      const Time = JSON.parse(sessionStorage.getItem('toggleDate')).time.split(
        '-'
      )
      const selectYear = Time[0]
      const selectMonth = Time[1]
      // console.log(this.month, parseInt(selectMonth))
      // console.log(selectYear, this.$dayjs().year())
      if (
        this.month === parseInt(selectMonth) &&
        +selectYear === +this.$dayjs().year()
      ) {
        // this.cutOffDate = this.$cUtils.format.formatDate(new Date((new Date()).getTime() - 86400000), 'yyyy-MM-dd')
        this.cutOffDate = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      } else {
        this.cutOffDate = this.$cUtils.format.formatDate(
          new Date(selectYear, selectMonth, 0),
          'yyyy-MM-dd'
        )
        // console.log(this.cutOffDate)
      }
    },
    getNavLeftTarget (name) {
      if (name === 'index') {
        return '#select-mounth'
      }
    },
    handleClickLink (name) {
      if (this.keyCode) {
        this.keyCode = 0
      } else {
        if (name !== this.$route.name) {
          window.location = name
          // this.$router.push({ name })
        }
      }
    },
    async onChangeTab (context, curTabId) {
      // console.log('onChangeTab:', this.prevId, curTabId)
      this.pageNum = parseInt(curTabId)
      if (this.prevId !== curTabId) {
        // 切换tab后需要rebind
        // bugfix：jquery和vue同时操作了真实dom，jquery添加btnFocus的操作会被覆盖，所以这里需要nextTick后处理，并在vue里添加btnFocus类
        // this.handleTabsScrollX(this.prevTabId, curTabId)

        await this.$nextTick()
        this.bindKey()

        // 处理边界阴影
        // this.handleTabsEdgeMask()
      } else {
        // this.handleTabShakeAnim(this.prevPanelId, curTabId)
      }
    },
    handleBack () {
      const returnPage = localStorage.getItem('returnPage')
      window.location = returnPage || '/'
      localStorage.removeItem('returnPage')
      // if (this.keyCode) {
      //   this.keyCode = 0
      // } else {
      //   this.$router.go(-1)
      //   // history.back(-1)
      //   // const routeInfo = this.$store.state.app.routeInfo
      //   // this.$router.push({
      //   //   name: routeInfo.name,
      //   //   query: routeInfo.query
      //   // })
      // }
      // location.href = '#/media-financial'
    },
    bindKey (target) {
      const getTarget = target ? '#' + target : null
      CCMap.init('.coocaa_btn', getTarget, 'btnFocus')
      const vm = this
      $('.coocaa_btn')
        .unbind()
        .bind('itemClick', function (e) {
          const rel = $(this).attr('rel')
          if (rel === 'back') {
            const returnPage = localStorage.getItem('returnPage')
            window.location = returnPage || '/'
            localStorage.removeItem('returnPage')
            // vm.$router.go(-1)
            // const routeInfo = vm.$store.state.app.routeInfo
            // vm.$router.push({
            //   name: routeInfo.name,
            //   query: routeInfo.query
            // })
            // location.href = '#/media-financial'
          }
          if (rel === 'ss_project') {
            const projectid = $(this).attr('dashboardId')
            const status = $(this).attr('status')
            if (status === '1') {
              vm.$store.dispatch('toggleRoute', {
                name: vm.$route.name,
                query: vm.$route.query
              })
              localStorage.setItem(
                'returnPage',
                location.pathname + location.search
              )
              if (projectid) {
                window.location = `/kanban-config-view?id=${projectid}`
                // vm.$router.push({
                //   name: 'kanbanConfigView',
                //   query: {
                //     id: projectid
                //   }
                // })
              } else {
                window.location.href = `/ssp-project?id=20`
              }
            }
          }
          if (rel === 'digitalDetails') {
            localStorage.setItem(
              'returnPage',
              location.pathname + location.search
            )
            location.href = $(this).attr('router')
            // vm.$router.push({
            //   name: $(this).attr('routerName'),
            //   query: JSON.parse($(this).attr('routerQuery'))
            // })
          }
          if (rel === 'selectMonth') {
            localStorage.setItem(
              'returnPage',
              location.pathname + location.search
            )
            location.href = '/select-month'
          }
          const _depLink = $(this).attr('depLink')
          if (_depLink) {
            window.location = _depLink
          }
        })
        .bind('itemFocus', function (e) {
          // console.log('itemFocus..')
          const _tabHref = $(this).find('span').attr('src')
          const _tabId = $(this).attr('id')
          const rel = $(this).attr('rel')
          const routeName = $(this).find('span').attr('routeName')
          // if (this.isAndroid) {
          //   alert(_tabHref)
          // } else {
          //   console.log(_tabHref)
          // }
          if (_tabHref && rel) {
            if (window.location.pathname !== routeName) {
              window.location = routeName
            }
            // vm.$router.push({
            //   name: routeName
            // })
            // location.href = _tabHref
          }
          const _rel = $(this).attr('rel')
          if (_rel === 'ss_project') {
            const elTop = $(this).position().top
            const elHeight = $(this).height()
            const boxHeight = $('#ss_box').height()
            const scrollTop = $('#ss_box').scrollTop()
            if (elTop < 0) {
              if (Math.abs(elTop) > scrollTop) {
                $('#ss_box').scrollTop(0)
              } else {
                $('#ss_box').scrollTop(scrollTop + elTop)
              }
            }
            if (elTop > boxHeight) {
              const scrollHeight = elTop + elHeight - boxHeight + scrollTop
              $('#ss_box').scrollTop(scrollHeight)
            } else {
              if (elTop + elHeight > boxHeight) {
                const scrollHeight = elTop + elHeight - boxHeight + scrollTop
                $('#ss_box').scrollTop(scrollHeight)
              }
            }
            // console.log(elTop, elHeight, boxHeight)
          }
          _tabId && vm.onChangeTab(this, _tabId)
        })
        .bind('itemBlur', function (e) {
          const itemId = $(this).attr('id')
          // console.log('itemBlur..', itemId)
          vm.prevId = itemId
        })
    },
    setShowSelectDate (val, oldValue) {
      if (this.isAndroid) {
        // 如果是电视Android打开，只有首页可以选择月份开
        if (this.$route.name === 'index' || this.$route.meta.hideInMenu) {
          this.showSelectDate = true
        } else {
          this.showSelectDate = false
        }
      } else {
        this.showSelectDate = this.$route.meta.showSelectDate ?? true
      }
    },
    jumpPage () {
      window.open('https://coocaa.feishu.cn/docx/TnladWViBoQTp0xpacac38lonjb')
    }
    // handleExitApp () {
    //   const _this = this
    //   document.onkeydown = function (e) {
    //     let key = window.event.keyCode
    //     _this.keyCode = key
    //     if ((key === 4 || key === 8)) {
    //       if (_this.$route.name === 'index') {
    //         alert('exit_app')
    //       } else {
    //         _this.$router.push({ name: 'index' })
    //       }
    //     }
    //   }
    // }
  },
  mounted () {
    this.bindKey(this.$route.name)
    this.$bus.$emit('fullScreenUpdate')
  },
  created () {
    this.getMenuAuth()
    this.getAllMenuList()
    // this.handleExitApp()
    this.setShowSelectDate()
  },
  activated () {
    this.setCutOffDate()
  }
}
</script>

<style lang="stylus" scoped>
.iscustomRouter {
  min-height 100vh !important
}
#main-wrap
  width 100vw
  height 100vh
  overflow auto
#main
  transform-origin: left top;
.return-page
  background rgba(255, 255, 255, .1)
  color #fff
  font-size .8rem
  height 1.7rem
  padding 0 1rem
  margin-top .75rem
  border-radius .4rem
  cursor pointer
  .el-icon-arrow-right
    font-size 1rem
    font-weight bold
    vertical-align middle
.main-header
  background #1A1939
  height 3.2rem
  display flex
  padding  0 1rem
  .header-left
    font-size 1.2rem
    height 3.2rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
    .xx
      float left
    .logo
      background-repeat no-repeat
    img
      display inline-block
      margin-right .3rem
      vertical-align text-bottom
      height 1.1rem
    span
      font-size .8rem
      color rgba(255,255,255,.6)
      padding-left .5rem
    .marquee-button
      position relative
      overflow hidden
      float left
      height 2.4rem
      width 6.4rem
      border-radius 5px
      margin-top 0.6rem
      margin-left 0.8rem
      cursor pointer
      z-index 2
      padding 0

    .marquee-button::before
        content: ''
        height 2.4rem
        width 6.4rem
        position absolute
        animation myAnimate 4s linear infinite
        top -50%
        left 50%
        background linear-gradient(transparent, transparent, #fff)
        transform-origin bottom left

    .marquee-button::after
        content: ''
        height 2.4rem
        width 6.4rem
        position absolute
        animation myAnimate 4s linear infinite
        top 50%
        left -50%
        background linear-gradient(#fff, transparent, transparent)
        transform-origin top right

      @keyframes myAnimate
          0%
              transform: rotate(0deg)

          100%
              transform: rotate(360deg)

    .marquee-button-text
        text-align center
        background-color #007bff
        height 2rem
        width 6rem
        color white
        border-radius 5px
        position absolute
        left 0.2rem
        top  0.2rem
        z-index 3
        padding 0 0.5rem
        box-sizing border-box
        line-height 2rem

  .header-right
    height 1.6rem
    line-height 1.6rem
    font-size .9rem
.nav
  padding-top .7rem
  ul
    list-style none
    margin 0
    padding 0
    display flex
    justify-content flex-end
    li
      span
        color rgba(255,255,255,.4)
        padding 0 1rem
        box-sizing border-box
        line-height 1.8rem
        display block
        cursor pointer
.nav li span.curTab
  color #fff
  &:after
    content ''
    display block
    width 1.2rem
    height .15rem
    background #fff
    margin 0 auto
    border-radius 1rem
.coocaa_btn.btnFocus
  transition transform 0.2s linear
  // transform scale(1.025, 1.025)
  border-radius 8px
  box-sizing border-box
  background #007EFF
  span
    color rgba(255,255,255,1)
    &:after
      opacity 0
.main-body
  padding 1rem
  padding-bottom 0
  // margin-top 1rem
  //height calc(100vh - 4.2rem)
  flex-grow: 1
  display flex
  // width calc(100vw - 2rem)
  // margin 1rem auto 0 auto
  overflow hidden
.no-data
  height :100vh
  display:flex
  align-items: center
  justify-content: center
  color:#FFFFFF
  font-size:28px
#select-mounth
  border 1px solid rgba(255,255,255,.2)
  background none
  line-height 1.6rem
  margin-left .5rem
  margin-top .8rem
  padding-right .4rem
  border-radius .2rem
  cursor pointer
#select-mounth.btnFocus
  background #007EFF
  color #fff
</style>
<style lang="stylus">
.coocaa_btn:not(.btnFocus) .coocaa_btn_hover
  opacity 0
.coocaa_btn.btnFocus .coocaa_btn_hover
  display block
  position absolute
  opacity 1
  transition opacity 0.2s linear
  // transform scale(1.025, 1.025)
  font-size 36px
  border-radius 10px
  box-sizing border-box
  width 100%
  height 100%
  border 3px solid #007EFF
  top 0
  left 0
</style>
